export enum ApplicationName {
  SaasApi = "SaasApi",
  // Add other application names here
}
